// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1-Yo6","productName":"Table_productName__2nilm"};